export default {
  defaultOption: 'NetBuyVol',

  screen: {
    1: 'Overview',
    2: 'Performance',
    3: 'Financial',
    4: 'Technical',
  },
};
